import script from "./ProfileHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&setup=true&lang=js"

import "./ProfileHeader.vue?vue&type=style&index=0&id=f3a40658&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3a40658"]])

export default __exports__